import { WebParameterContext, WebResponesContext } from '../../model/common';
export class ServicesPromoterInspection {
    constructor() {

    }
    public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
       
        // console.log(webcontext);
        if(webcontext.OpType.toLowerCase()=="add" || webcontext.OpType.toLowerCase()=="edite"){
            let body=JSON.parse(webcontext.RequestBody);
            console.log(body,"PromoterInspection");
            let fk_TBStore_ID:any=null;
            if(localStorage.getItem("tbstore")){
                fk_TBStore_ID=JSON.parse(localStorage.getItem("tbstore")).ID;
            }
            if(webcontext.OpType.toLowerCase()=="add"){
                if(!body.a_FK_Systemuser_ID){
                    body.a_FK_Systemuser_ID=webcontext.ID;
                }
                body.a_FK_Store_ID=fk_TBStore_ID;
            }
           webcontext.RequestBody = JSON.stringify(body);
        }
        // webcontext.ResponseMessage.Success=false;
        return webcontext;
    }
    public HandleServerContextAfterDBRequest(webParameterContext: WebParameterContext, webContext: WebResponesContext): WebResponesContext {
        return webContext;
    }
}